namespace RedBullMOBILE360.ESim {
    export interface EsimActivationCodeForm {
        Iccid: Serenity.StringEditor;
        CreationDate: Serenity.DateEditor;
        ActivationCode: Serenity.StringEditor;
        Pin: Serenity.StringEditor;
        Puk: Serenity.StringEditor;
    }

    export class EsimActivationCodeForm extends Serenity.PrefixedContext {
        static formKey = 'ESim.EsimActivationCode';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EsimActivationCodeForm.init)  {
                EsimActivationCodeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;

                Q.initFormType(EsimActivationCodeForm, [
                    'Iccid', w0,
                    'CreationDate', w1,
                    'ActivationCode', w0,
                    'Pin', w0,
                    'Puk', w0
                ]);
            }
        }
    }
}
